export const CURRENCY_FORMAT = {
  currency: 'EUR',
  minimumFractionDigits: 0,
  maximumFractionDigits: 2
};
